import { Pipe, PipeTransform } from '@angular/core';

import { PEDIDOS_MOTIVOS_NAO_LIBERADOS } from '../domain';

@Pipe({
    name: 'pedidoMotivoNaoLiberado'
})
export class PedidoMotivoNaoLiberadoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = PEDIDOS_MOTIVOS_NAO_LIBERADOS.findIndex(status => status.id === value);
        if (index > -1) {
            return PEDIDOS_MOTIVOS_NAO_LIBERADOS[index].nome;
        }
        return '';
    }
}
